var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.specialsByPosition.length > 0)?_c('div',{staticClass:"df-space-y-4"},_vm._l((_vm.specialsByPosition),function(special){return _c('df-card-special',{key:special.uniqueId,attrs:{"promotion":_vm.promotion,"special":special}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }